module.exports = __webpack_public_path__ + "static/media/22-3.5550f734.mp3";